<template>
  <v-container v-if="user" fluid>
    <v-card>
      <v-card-title class="text-center teal lighten-3 accent-4 white--text">
        Corte
      </v-card-title>
      <v-row class="mx-2 mt-1">
        <v-col cols="12" lg="3" md="3">
          <v-select
            v-model="sucursalSelected"
            :items="sucursales"
            item-value="value"
            label="Sucursal"
            placeholder="Selecciona sucursal"
          ></v-select>
        </v-col>
        <!-- Selector de fecha completa -->
        <v-col cols="12" lg="3" md="3">
          <v-menu
            ref="menuFecha"
            v-model="menuFecha"
            :close-on-content-click="false"
            :return-value.sync="selectedDate"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="formattedDate"
                label="Fecha"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="selectedDate"
              @change="onDateSelected"
              locale="es"
              @input="menuFecha = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="2">
          <v-btn @click="fetchData" small class="mt-5" :loading="loading"
            >Buscar</v-btn
          >
        </v-col>
      </v-row>
      <v-row class="mx-2 mt-1">
        <v-col cols="12" lg="3" md="3">
          <v-text-field
            v-if="tableData.length"
            label="Búsqueda"
            v-model="search"
            append-icon="mdi-magnify"
            clearable
          />
        </v-col>
        <v-col cols="12" lg="6" md="6">
          <!-- Tabla de resultados -->
          <p class="text-center mt-6" v-if="tableData.length">
            <b>Fecha:</b> {{ formattedDate }} - <b>Total:</b>
            {{ sumTotal }}
          </p>
        </v-col>
        <v-col cols="12" lg="3" md="3">
          <v-btn
            v-if="tableData.length"
            class="mt-6"
            color="primary"
            @click="downloadExcel"
          >
            Descargar Excel
          </v-btn>
        </v-col>
      </v-row>

      <v-data-table
        v-if="tableData.length"
        :headers="headers"
        :items="tableData"
        :search="search"
        class="elevation-1 ma-2"
        :footer-props="{
          'items-per-page-text': 'Elementos por página',
        }"
        :header-props="{
          'sort-by-text': 'Ordenar por',
        }"
      >
        <template v-slot:[`item.usuario`]="{ item }">
          {{ item.usuario === 0 ? "Sin usuario" : item.usuario }}
        </template>
        <template v-slot:[`item.total`]="{ item }">
          {{ "$" + item.total }}
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
//import * as XLSX from "xlsx";

export default {
  data() {
    return {
      search: "",
      loading: false,
      selectedDate: new Date().toISOString().slice(0, 10),
      formattedDate: new Date().toISOString().slice(0, 10),
      menuFecha: false,
      tableData: [],
      sucursalSelected: this.currentUser?.sucursal || "Mexicali",
      sucursales: [
        {
          text: "Mexicali",
          value: "Mexicali",
        },
        {
          text: "Tijuana",
          value: "Tijuana",
        },
        {
          text: "Ensenada",
          value: "Ensenada",
        },
        {
          text: "La Paz",
          value: "LaPaz",
        },
        {
          text: "Obregón",
          value: "Obregon",
        },
        {
          text: "Hermosillo",
          value: "Hermosillo",
        },
      ],
      headers: [
        {
          text: "Concepto",
          value: "concepto",
        },
        {
          text: "Serie y Folio",
          value: "serie_folio",
        },
        {
          text: "Codigo cliente",
          value: "codigo_cliente",
        },
        {
          text: "Razón social",
          value: "razon_social",
          // sortable: false,
        },
        {
          text: "Total",
          value: "total",
        },
        {
          text: "Usuario",
          value: "usuario",
        },
        {
          text: "Hora",
          value: "hora",
        },
      ],
    };
  },
  methods: {
    CalculateSumTotal() {
      const sum = this.tableData.reduce((acc, item) => acc + item.total, 0);
      return sum.toLocaleString("es-MX", {
        style: "currency",
        currency: "MXN",
      });
    },

    onDateSelected() {
      const date = new Date(this.selectedDate);
      this.formattedDate = date.toISOString().split("T")[0];
      this.$refs.menuFecha.save(this.selectedDate);
      this.menuFecha = false;
    },

    async fetchData() {
      this.loading = true;
      try {
        const response = await axios.get(`/reportes/get_corte`, {
          params: {
            fecha: this.selectedDate,
            sucursal: this.sucursalSelected,
          },
        });

        const facturas = response.data;

        if (facturas && facturas.data && facturas.index && facturas.columns) {
          // Mapear los datos de la respuesta
          this.tableData = facturas.index.map((idx, i) => {
            const facturaData = facturas.data[i]; // Accede a los datos por índice
            const factura = {};

            // Construir el objeto dinámicamente usando las columnas
            facturas.columns.forEach((column, colIndex) => {
              factura[column] = facturaData[colIndex];
            });

            factura.serie_folio = `${factura.serie} - ${factura.folio}`;

            // Convertir hora a string y formatear
            if (factura.hora && typeof factura.hora !== "undefined") {
              const horaStr = String(factura.hora).padStart(4, "0"); // Asegurar 4 dígitos
              const horas = parseInt(horaStr.slice(0, 2), 10);
              const minutos = horaStr.slice(2, 4);
              const periodo = horas >= 12 ? "PM" : "AM";
              const horas12 = horas % 12 || 12;
              factura.hora = `${horas12}:${minutos} ${periodo}`;
            } else {
              factura.hora = "Sin hora";
            }

            return {
              index: idx,
              ...factura, // Agregar los datos dinámicos
            };
          });
        }
        /* this.tableData = facturas.map((factura) => ({
          serie_folio: `${factura.serie} - ${factura.folio}`,
          codigo_cliente: factura.codigo_cliente,
          rfc: factura.rfc,
          razon_social: factura.razon_social,
          concepto: factura.concepto,
          total: factura.total,
        }));*/
      } catch (error) {
        if (error.response && error.response.status === 404) {
          alert("No hay facturas para la fecha seleccionada.");
          this.loading = false;
          return;
        }
        console.error("Error al obtener los datos:", error);
      }
      this.loading = false;
    },

    async downloadExcel() {
      try {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Corte Factura");

        const currentDate = new Date().toLocaleString();

        // Encabezados superiores
        worksheet.addRow(["Corte Factura"]).font = { bold: true };
        worksheet.addRow([`Sucursal: ${this.sucursalSelected}`]).font = {
          bold: true,
        };
        worksheet.addRow([`Total: ${this.sumTotal}`]).font = { bold: true };
        worksheet.addRow([`Fecha de impresión: ${currentDate}`]).font = {
          bold: true,
        };

        worksheet.addRow([]); // espacio visual

        // Headers tabla
        const headers = [
          "Fecha",
          "Concepto",
          "Serie - Folio",
          "Codigo Cliente",
          "Razón Social",
          "Total",
          "Efectivo",
          "Tarjeta",
          "Dolares",
          "Transferencia",
          "Usuario",
          "Hora",
        ];

        const headerRow = worksheet.addRow(headers);

        // Estilo header
        headerRow.eachCell((cell) => {
          cell.font = { bold: true };
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "97DDE1" },
          };
          cell.alignment = { horizontal: "center" };
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        });

        // Totales
        let totalGeneral = 0;
        let totalEfectivo = 0;
        let totalTarjeta = 0;
        let totalDolares = 0;
        let totalTransferencia = 0;

        // Data
        this.tableData.forEach((factura) => {
          const total = Number(factura.total) || 0;

          totalGeneral += total;

          let efectivo = 0;
          let tarjeta = 0;
          let dolares = 0;
          let transferencia = 0;

          if (factura.metodo_de_pago === "Efectivo") {
            totalEfectivo += total;
            efectivo = total;
          }

          if (factura.metodo_de_pago === "Tarjeta") {
            totalTarjeta += total;
            tarjeta = total;
          }

          if (factura.metodo_de_pago === "Dolares") {
            totalDolares += total;
            dolares = total;
          }

          if (factura.metodo_de_pago === "Transferencia") {
            totalTransferencia += total;
            transferencia = total;
          }

          const row = worksheet.addRow([
            this.formattedDate,
            factura.concepto,
            factura.serie_folio,
            factura.codigo_cliente,
            factura.razon_social,
            total,
            efectivo,
            tarjeta,
            dolares,
            transferencia,
            factura.usuario,
            factura.hora,
          ]);

          // Formato moneda
          [6, 7, 8, 9, 10].forEach((col) => {
            const cell = row.getCell(col);
            cell.numFmt = '"$"#,##0.00';
            cell.alignment = { horizontal: "right" };
          });
        });

        // Fila TOTAL
        const totalRow = worksheet.addRow([
          "",
          "",
          "",
          "",
          "TOTAL",
          totalGeneral,
          totalEfectivo,
          totalTarjeta,
          totalDolares,
          totalTransferencia,
          "",
          "",
        ]);

        [5, 6, 7, 8, 9, 10].forEach((col) => {
          const cell = totalRow.getCell(col);

          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "BABABA" },
          };

          cell.font = { bold: true };

          cell.numFmt = col >= 6 ? '"$"#,##0.00' : undefined;

          cell.alignment = {
            horizontal: col >= 6 ? "right" : "center",
          };

          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        });

        // Bordes generales
        worksheet.eachRow((row) => {
          row.eachCell((cell) => {
            cell.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            };
          });
        });

        // AUTO AJUSTE REAL DE COLUMNAS
        worksheet.columns.forEach((column) => {
          let maxLength = 0;

          column.eachCell({ includeEmpty: true }, (cell) => {
            let value = cell.value;

            if (!value) return;

            if (typeof value === "object") {
              value =
                value.text || value.richText?.map((t) => t.text).join("") || "";
            }

            value = value.toString();

            maxLength = Math.max(maxLength, value.length);
          });

          column.width = Math.min(maxLength + 2, 35);
        });

        // Extra: columna larga
        worksheet.getColumn(5).width = 40;

        // Exportar
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), `Corte_${this.formattedDate}.xlsx`);
      } catch (error) {
        console.error("Error al generar el archivo Excel:", error);
      }
    },
  },
  created() {},
  mounted() {},
  watch: {},
  components: {},
  computed: {
    ...mapGetters(["user", "currentUser"]),
    sumTotal() {
      return this.CalculateSumTotal();
    },
  },
};
</script>
